import React from 'react'
import './Trusted_By_Million.css'

const Trusted_By_Million = () => {
  return (
    <section className='Trusted_By_Million'>
        <div className='container'>
            <div className='content_div'>
                <p className='title_text'>Trusted by a Million</p>
                <p className='sub_text'> Become Part of the Majesty Family.</p>
            </div>
        </div>
    </section>
  )
}

export default Trusted_By_Million
